import React, { useMemo, useState } from "react";
import PaperCard from "../../dashboard/components/PaperCard";

export default function DiscoveredPapers({ papers, message }) {
  const [selectedImage, setSelectedImage] = useState(null);
  const sortedPapers = useMemo(() => {
    return papers
      .map((paper, index) => ({
        paper,
        index,
        score:
          paper.relevance_score === undefined || paper.relevance_score === null
            ? -1
            : paper.relevance_score,
      }))
      .sort((a, b) => {
        if (a.score === b.score) {
          return a.index - b.index;
        }
        return b.score - a.score;
      })
      .map((entry) => entry.paper);
  }, [papers]);

  return (
    <div className="space-y-4 animate-fade-in">
      {message && (
        <p className="text-xs text-gray-500 px-1">{message}</p>
      )}
      <div className="grid grid-cols-1 gap-4">
        {sortedPapers.map((paper, idx) => (
          <PaperCard
            key={paper.pmid || paper.url || idx}
            index={idx}
            paper={paper}
            isContextSelected={false}
            onToggleContext={() => {}}
            showContextButton={false}
            isBookmarked={false}
            bookmarkDisabled={true}
            onToggleBookmark={() => {}}
            handleReferenceClick={() => {}}
            setSelectedImage={setSelectedImage}
            isLoading={true}
          />
        ))}
      </div>

      {selectedImage && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90 p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-4 right-4 text-white hover:text-gray-300"
          >
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <img
            src={selectedImage}
            alt="Full size figure"
            className="max-w-full max-h-[90vh] object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}
